<template>
  <CRow class="justify-content-center">
    <Modal :modal="modal"></Modal>

    <!-- Content -->
    <CCol col="12">
      <CForm @submit.prevent="send">
        <!-- Back -->
        <CRow>
          <CCol lg="12">
            <div class="d-flex align-items-center justify-content-end mb-3">
              <a
                href="javascript:void(0)"
                @click="$router.go(-1)"
              ><CIcon
                name="cil-arrow-left"
                class="mr-2"
              />Voltar</a>
            </div>
          </CCol>
        </CRow>

        <!-- Title -->
        <CCard>
          <CCardHeader>
            <div class="d-flex justify-content-between align-items-center">
              <h4 class="mb-0">
                {{ $route.params.id ? 'Editar Diretoria' : 'Cadastrar Diretoria' }}
              </h4>

              <div class="d-flex align-items-center">
                <div class="ml-2 d-flex align-items-center">
                  <label class="mb-0">
                    <b>Status</b>
                  </label>
                  <CSwitch
                    type="checkbox"
                    color="success"
                    variant="3d"
                    class="mx-2"
                    v-bind="labelIcon"
                    :checked.sync="form.status"
                  />
                </div>
              </div>
            </div>
          </CCardHeader>
        </CCard>

        <!-- Content -->
        <CCard>
          <CCardBody>
            <CTabs
              :active-tab="activeTabIndex"
              :vertical="vertical"
              :variant="variant"
              add-nav-wrapper-classes="website-tabs"
              add-tabs-wrapper-classes="website-tabs"
              class="ml-1"
              @update:activeTab="handleActiveTab"
            >
              <!-- BR -->
              <CTab>
                <!-- Tab title -->
                <template
                  slot="title"
                >
                  <div class="d-flex align-items-center">
                    <img
                      :src="require(`@/assets/img/flags/pt-br.svg`)"
                      alt="Bandeira Inglesa"
                      class="flag mr-2"
                    />
                    Português
                    <TabsStatus :exibition="form.status" />
                  </div>
                </template>

                <!-- Fields -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    Informações
                  </h5>
                </div>

                <CRow>
                  <CCol lg="12">
                    <CRow>
                      <!-- Office -->
                      <CCol lg="4">
                        <div class="form-group">
                          <label for="">Cargo*</label>
                          <Multiselect
                            :value="officeOptions.find(option => option.value == form.charge_id)"
                            :options="officeOptions"
                            label="label"
                            track-by="value"
                            :disabled="processing"
                            @select="(selected) => form.charge_id = selected.value"
                          />
                        </div>
                      </CCol>

                      <!-- Name -->
                      <CCol lg="4">
                        <CInput
                          id="first"
                          v-model="form.name"
                          label="Nome*"
                          :disabled="processing"
                        />
                      </CCol>

                      <!-- Occupation -->
                      <CCol lg="4">
                        <CInput
                          v-model="form.occupation"
                          label="Função*"
                          :disabled="processing"
                        />
                      </CCol>
                    </CRow>

                    <!-- Biography -->
                    <CRow>
                      <CCol lg="12">
                        <div class="form-group">
                          <CTextarea
                            v-model="form.biography"
                            label="Biografia"
                            placeholder=""
                            :disabled="processing"
                            maxlength="200"
                          />
                        </div>
                      </CCol>
                    </CRow>

                    <CRow class="mb-2">
                      <CCol lg="12">
                        <small class="text-sm text-muted float-right">
                          {{ form.biography ? form.biography.length : 0 }}/{{
                            200
                          }}
                          caracteres
                        </small>
                      </CCol>
                    </CRow>

                    <!-- Image -->
                    <CRow>
                      <CCol lg="12">
                        <FileUploader
                          id="direction-image"
                          :enable-multiple="false"
                          :uploader-info="uploaderInfo"
                          :enable-crop-on-uploader="true"
                          :enable-edit-on-api-table="false"
                          :max-files="1"
                          :accept-types="acceptTypes"
                          :extensions="extensions"
                          :medias="form.main_image"
                          :min-cropped-width="265"
                          :min-cropped-height="168"
                          :disabled="processing"
                        />
                      </CCol>
                    </CRow>
                  </CCol>
                </CRow>
              </CTab>

              <!-- EN -->
              <CTab>
                <!-- Tab title -->
                <template
                  slot="title"
                >
                  <div class="d-flex align-items-center">
                    <img
                      :src="require(`@/assets/img/flags/en.svg`)"
                      alt="Bandeira Inglesa"
                      class="flag mr-2"
                    />
                    Inglês
                    <TabsStatus :exibition="form.status_en && form.status" />
                  </div>
                </template>

                <!-- Title -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    Informações
                  </h5>

                  <div class="d-flex align-items-center">
                    <div class="ml-2 d-flex align-items-center">
                      <label class="mb-0">
                        <b>Exibir</b>
                      </label>

                      <CSwitch
                        type="checkbox"
                        color="success"
                        variant="3d"
                        class="mx-2"
                        v-bind="labelIcon"
                        :checked.sync="form.status_en"
                      />
                    </div>
                  </div>
                </div>

                <!-- Fields -->
                <CRow>
                  <CCol col="12">
                    <CInput
                      v-model="form.occupation_en"
                      :label="`Função*`"
                      :disabled="processing"
                    />
                  </CCol>
                </CRow>

                <CRow>
                  <CCol col="12">
                    <CTextarea
                      v-model="form.biography_en"
                      label="Biografia"
                      placeholder=""
                      :disabled="processing"
                      maxlength="200"
                    />
                  </CCol>
                </CRow>

                <CRow>
                  <CCol lg="12">
                    <small class="text-sm text-muted float-right">
                      {{ form.biography_en ? form.biography_en.length : 0 }}/{{
                        200
                      }}
                      caracteres
                    </small>
                  </CCol>
                </CRow>
              </CTab>

              <!-- ES -->
              <CTab>
                <!-- Tab title -->
                <template slot="title">
                  <div class="d-flex align-items-center">
                    <img
                      :src="require(`@/assets/img/flags/es.svg`)"
                      alt="Bandeira Espanhola"
                      class="flag mr-2"
                    />
                    Espanhol
                    <TabsStatus :exibition="form.status_es && form.status" />
                  </div>
                </template>

                <!-- Title -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    Informações
                  </h5>

                  <div class="d-flex align-items-center">
                    <div class="ml-2 d-flex align-items-center">
                      <label class="mb-0">
                        <b>Exibir</b>
                      </label>

                      <CSwitch
                        type="checkbox"
                        color="success"
                        variant="3d"
                        class="mx-2"
                        v-bind="labelIcon"
                        :checked.sync="form.status_es"
                      />
                    </div>
                  </div>
                </div>

                <CRow>
                  <CCol col="12">
                    <CInput
                      v-model="form.occupation_es"
                      :label="`Função*`"
                      :disabled="processing"
                    />
                  </CCol>
                </CRow>

                <CRow>
                  <CCol col="12">
                    <CTextarea
                      v-model="form.biography_es"
                      label="Biografia"
                      placeholder=""
                      :disabled="processing"
                      maxlength="200"
                    />
                  </CCol>
                </CRow>

                <CRow>
                  <CCol lg="12">
                    <small class="text-sm text-muted float-right">
                      {{ form.biography_es ? form.biography_es.length : 0 }}/{{
                        200
                      }}
                      caracteres
                    </small>
                  </CCol>
                </CRow>
              </CTab>
            </CTabs>
          </CCardBody>
        </CCard>

        <!-- Logs -->
        <CRow v-if="$route.params.id">
          <CCol sm="12">
            <CardLog :log="log" />
          </CCol>
        </CRow>

        <!-- Actions -->
        <div class="form-actions">
          <a
            v-if="$route.params.id"
            href="javascript:void(0)"
            class="mr-3"
            @click="resetForm"
          >Limpar Alterações</a>
          <CInputCheckbox
            v-else
            label="Criar outro"
            class="mr-3"
            :disabled="processing"
            @update:checked="setRedirect"
          />
          <CButton
            color="success"
            type="submit"
            :disabled="processing"
          >
            {{ processing ? 'Salvando...' : 'Salvar' }}
          </CButton>
        </div>
      </CForm>
    </CCol>
  </CRow>
</template>

<script>
// Components
import FileUploader from '@/components/ui/Fileuploader'
import Modal from '@/components/ui/Modal'
import Multiselect from '@/components/ui/Multiselect'
import TabsStatus from '@/components/ui/TabsStatus'
import CardLog from '@/components/ui/CardLog'

import { cloneDeep } from 'lodash'
import moment from 'moment'

// Services
import Service from '@/services/direction.service'

export default {
  metaInfo: {
    title: 'Diretoria',
    titleTemplate: ' %s - Manager - Intelli'
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.$store.state.auth.permissions.includes('manage_directorships')) {
        vm.$router.push('/404')
      }
    })
  },

  components: {
    FileUploader,
    Modal,
    Multiselect,
    TabsStatus,
    CardLog
  },

  data() {
    return {
      labelIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      vertical: false,
      variant: 'tabs',
      form: {},
      item: {
        id: '',
        status: true,
        main_image_id: '',
        main_image: [],
        charge_id: '',
        name: '',
        occupation: '',
        occupation_en: '',
        occupation_es: '',
        biography: '',
        biography_en: '',
        biography_es: '',
        status_en: false,
        status_es: false
      },
      officeOptions: [
        {
          label: 'Presidência',
          value: '1'
        },
        {
          label: 'Diretoria',
          value: '2'
        }
      ],
      acceptTypes: 'image/png,image/jpeg',
      extensions: 'jpg,jpeg,png',
      uploaderInfo: {
        label: 'Imagem'
      },
      processing: false,
      new: true,
      log: {
        created_by: 'Admin',
        created_at: '20/09/2021',
        updated_by: 'Admin',
        updated_at: '20/09/2021'
      },
      query: {
        sorter: {}
      },
      modal: {
        show: false,
        title: '',
        message: '',
        color: ''
      },
      activeTabIndex: 0,
      redirect: true
    }
  },

  async created() {
    this.setItem()
  },

  methods: {
    async setItem() {
      if (this.$route.params.id) {
        const data = await Service.show(this.$route.params.id)

        if (data) {
          this.item = {
            id: this.$route.params.id,
            status: !!data.status,
            main_image_id: data.main_image_id,
            main_image: data.main_image,
            charge_id: data.charge_id,
            name: data.name,
            occupation: data.occupation,
            occupation_en: data.occupation_en,
            occupation_es: data.occupation_es,
            biography: data.biography,
            biography_en: data.biography_en,
            biography_es: data.biography_es,
            status_en: !!data.status_en,
            status_es: !!data.status_es
          }

          this.log = {
            created_by: data.created ? data.created.name : 'Seed',
            created_at: moment(data.created_at).format('DD/MM/YYYY HH:mm'),
            updated_by: data.updated ? data.updated.name : null,
            updated_at: moment(data.updated_at).format('DD/MM/YYYY HH:mm')
          }
        }
      }

      this.form = cloneDeep(this.item)
    },

    resetForm() {
      this.setItem()
    },

    setRedirect(event) {
      this.redirect = !event
    },

    handleActiveTab(index) {
      this.activeTabIndex = index
    },

    async send() {
      this.processing = true

      let response
      let message

      const data = {
        id: this.$route.params.id,
        status: !!this.form.status,
        charge_id: this.form.charge_id,
        name: this.form.name,
        occupation: this.form.occupation,
        occupation_en: this.form.occupation_en,
        occupation_es: this.form.occupation_es,
        biography: this.form.biography,
        biography_en: this.form.biography_en,
        biography_es: this.form.biography_es,
        status_en: !!this.form.status_en,
        status_es: !!this.form.status_es,
        main_image_id: this.form.main_image && this.form.main_image.length ? this.form.main_image[0].id : null
      }

      if (this.$route.params.id) {
        response = await Service.update(this.$route.params.id, data)
        message = 'Diretoria foi atualizada com sucesso!'
      } else {
        response = await Service.store(data)
        message = 'Diretoria foi cadastrada com sucesso!'
      }

      this.processing = false

      if (response.status === 200) {
        this.modal = {
          show: true,
          title: 'Sucesso',
          message: message,
          color: 'success',
          redirect: this.redirect
        }

        if (this.redirect) {
          this.resetForm()
          setTimeout(() => {
            this.$router.push(
              this.$route.matched[this.$route.matched.length - 2].path
            )
          }, 3000)
        } else {
          this.resetForm()
          setTimeout(() => {
            this.processing = false
            document.getElementById('first').focus()
            this.modal.show = false
          }, 1000)
        }
      } else if (response.status === 400) {
        this.modal = {
          show: true,
          title: 'Erro',
          message: response.data.messages[0].message || response.data,
          color: 'danger'
        }
      } else {
        this.modal = {
          show: true,
          title: 'Erro',
          message: 'Ocorreu um erro interno, por favor tente novamente!',
          color: 'danger'
        }
      }
    }
  }
}
</script>
